module.exports = __webpack_public_path__ + "img/logo.8482e0b4.png";